import { FC, useEffect, useState } from "react"
import PreferencesRow from "../PreferencesRow"
import Toggle from "@/components/shared/Toggle"
import { Token } from "@/types/index"

interface LocationToggleProps {
   title: string
   description: string
}

const LocationToggle: FC<LocationToggleProps> = ({ title, description }) => {
   const [activeToggle, setActiveToggle] = useState<boolean>(true)

   useEffect(() => {
      const storedValue = localStorage.getItem(Token.LOCATION_VISIBILITY)
      if (storedValue !== null) {
         setActiveToggle(storedValue === "true")
      }
   }, [])

   useEffect(() => {
      localStorage.setItem(Token.LOCATION_VISIBILITY, String(activeToggle))
   }, [activeToggle])

   return (
      <PreferencesRow
         title={title}
         description={description}
      >
         <Toggle
            label=""
            value={activeToggle}
            onChange={() => setActiveToggle((activeToggle) => !activeToggle)}
            id="location-toggle"
         />
      </PreferencesRow>
   )
}

export default LocationToggle
